import "./DeleteCourseModal.scss";

import { FC, useState } from "react";

import { t } from "i18n/i18n";
import { LegacyButton } from "mds/components/LegacyButton";
import { showConfirmationModal } from "mds/components/Modal";
import { TextField } from "mds/components/TextField";
import { useAppSelector } from "store";
import { selectCourseCodeTitleByCourseId } from "store/selectors/course";

export const showDeleteConfirmationModal = ({
  courseId,
  courseTitle,
}: {
  courseId: string;
  courseTitle: string;
}) => {
  const deleteCourseTitle = t("confirm_delete_modal.delete_item", {
    item: t("glossary.course"),
  });

  return showConfirmationModal({
    title: deleteCourseTitle,
    hideCancelConfirmButtons: true,
    labelText: t("confirm_delete_modal.delete_label", { name: courseTitle }),

    children: (onClose, onConfirm) => (
      <DeleteCourseModal
        courseId={courseId}
        deleteCourseTitle={deleteCourseTitle}
        onClose={onClose}
        onConfirm={onConfirm}
      />
    ),
  });
};

type DeleteCourseModalProps = {
  deleteCourseTitle: string;
  courseId: string;
  onConfirm: (data?: boolean) => void;
  onClose: () => void;
};

// eslint-disable-next-line react-refresh/only-export-components
const DeleteCourseModal: FC<DeleteCourseModalProps> = ({
  courseId,
  deleteCourseTitle,
  onConfirm,
  onClose,
}) => {
  const [disableDelete, setDisableDelete] = useState<boolean>(true);

  const courseCodeTitle = useAppSelector((state) =>
    selectCourseCodeTitleByCourseId(state, courseId),
  );
  const handleCourseCodeConfirmationCheck = (text: string) => {
    setDisableDelete(text !== courseCodeTitle);
  };

  return (
    <div className="course-delete-modal mt-8 flex flex-col items-start gap-8">
      <div className="course-delete-warning">{t("course_list_panel.delete_course_warning")}</div>

      <div className="flex flex-col gap-2">
        <label htmlFor="course-code">{t("course_list_panel.course_code_confirm_label")}</label>

        <TextField
          id="course-code"
          placeholder={t("course_list_panel.course_code_placeholder")}
          isEditing
          onChange={(event) => handleCourseCodeConfirmationCheck(event.target.value)}
        />
      </div>

      <div className="flex w-full justify-end gap-2">
        <LegacyButton kind="secondary" title={t("common.cancel")} onClick={onClose}>
          {t("common.cancel")}
        </LegacyButton>

        <LegacyButton
          disabled={disableDelete}
          kind="destructive"
          title={deleteCourseTitle}
          onClick={() => onConfirm(true)}
        >
          {deleteCourseTitle}
        </LegacyButton>
      </div>
    </div>
  );
};
